import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';

import { KategoriaGrupaMapOpenDto } from '../modele/kategoria-grupa-map-open-dto';
import { environment } from 'src/environments/environment';
import { MapaDane, ZalacznikiOpisyDane } from 'src/app/modul-mapowy/serwis-mapowy/modele/mapa';

@Injectable({
  providedIn: 'root'
})
export class ControllerMapyService {
  basePHAPIUrl = environment.basePHAPIUrl;
  private pasekCzasuCache = new Map<string, KategoriaGrupaMapOpenDto>();
  private readonly CACHE_SIZE = 10;

  constructor(private http: HttpClient) { }

  getRodzajISciezkaDoPlikuZGrafika(uuid: string): Observable<KategoriaGrupaMapOpenDto> {
    return this.http.get<KategoriaGrupaMapOpenDto>(this.basePHAPIUrl + '/kategoriagrupamap/find/' + uuid);
  }

  getRodzajISciezkaDoPlikuZGrafikaDlaPaskaCzasu(uuid: string): Observable<KategoriaGrupaMapOpenDto> {
    const cached = this.pasekCzasuCache.get(uuid);
    if (cached) {
      return of(cached);
    }
    return this.http.get<KategoriaGrupaMapOpenDto>(
      this.basePHAPIUrl + '/kategoriagrupamap/find/' + uuid
    ).pipe(tap(result => {
      if (!this.pasekCzasuCache.has(uuid) && this.pasekCzasuCache.size >= this.CACHE_SIZE) {
        const oldestKey = this.pasekCzasuCache.keys().next().value;
        if (oldestKey) { this.pasekCzasuCache.delete(oldestKey); }

      }
      this.pasekCzasuCache.set(uuid, result);
    }));
  }

  getMapaDane(uuid: string): Observable<MapaDane> {
    return this.http.get<MapaDane>(this.basePHAPIUrl + '/mapydane/' + uuid);
  }

  getZalacznikOpisy(schemat: string, tabela: string, idObiektuKolumna: string, opisKolumna: string, opisAltKolumna: string, nazwaPlikuKolumna: string, idObiektu: string): Observable<ZalacznikiOpisyDane[]> {
    const params = new HttpParams({
      fromObject: {
        schemat: schemat,
        tabela: tabela,
        idObiektuKolumna: idObiektuKolumna,
        opisKolumna: opisKolumna,
        opisAltKolumna: opisAltKolumna,
        nazwaPlikuKolumna: nazwaPlikuKolumna,
        idObiektu: idObiektu
      }
    });

    return this.http.get<ZalacznikiOpisyDane[]>(this.basePHAPIUrl + '/zalacznikiopisy/', { params: params });
  }
}
